// ======================================================================
// File Name       : ContentNotificationDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// =======================================================================
import React from 'react';
import { Form, FormControl, Col, InputGroup, Button, Table } from 'react-bootstrap';
import Datetime from 'react-datetime';
import PaginationCustom from '../Pagination';
import { MODE } from '../../constants/index';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import TableHead from '../TableHead';
import { CONTENT_NOTIFICATION_DETAIL_TYPE } from '../../constants/ContentConstant';

const ContentNotificationDetail = ({ notificationData, isConfirmDialog }) => {
  const thead = [{ title: '表示条件', sortBy: null }, { title: 'メッセージファイル', sortBy: null }];
  const theadConfirm = [{ title: 'メッセージファイル', sortBy: null }];
  const style = {
    background: 'none',
    width: 'auto',
    marginLeft: 0,
    left: 0,
  };
  // table data
  let notifyMessageTableData = null;
  if (notificationData.notifyMessageList) {
    notifyMessageTableData = notificationData.notifyMessageList.map((notifyMessagetData, index) => (
      <tr key={index}>
        {isConfirmDialog === CONTENT_NOTIFICATION_DETAIL_TYPE.PAGE && (
          <td>{notifyMessagetData.timeCondition} 秒経過</td>
        )}
        <td>{notifyMessagetData.messageZipFileName}</td>
      </tr>
    ));
  }
  return (
    <div>
      <Form className="margin-10">
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            通知メッセージ識別ID
          </Col>
          <Col sm={7} as={Form.Label}>
            {notificationData.notifyMessageSetSecernId}
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            通知メッセージ名
          </Col>
          <Col sm={7} as={Form.Label}>
            {notificationData.notifyMessageSetName}
          </Col>
        </Form.Group>
        {isConfirmDialog === CONTENT_NOTIFICATION_DETAIL_TYPE.PAGE && (
          <Form.Group className="form-info label-middle">
            <Col as={Form.Label} sm={3}>
              通知メッセージ
            </Col>
            <Col sm={9}>
              <Table striped hover className="margin-top-10 table-layout-auto">
                <thead>
                  <TableHead data={thead} />
                </thead>
                <tbody>{notifyMessageTableData}</tbody>
              </Table>
            </Col>
          </Form.Group>
        )}
        {isConfirmDialog === CONTENT_NOTIFICATION_DETAIL_TYPE.DIALOG && (
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              通知メッセージ
            </Col>
            <Col sm={7}>
              <Table striped hover className="margin-top-10">
                <thead>
                  <TableHead data={theadConfirm} />
                </thead>
                <tbody>{notifyMessageTableData}</tbody>
              </Table>
            </Col>
          </Form.Group>
        )}
      </Form>
    </div>
  );
};
export default ContentNotificationDetail;
